module.exports = __webpack_public_path__ + "static/drone-21fe6ae6893e8698ca06b44b5b354d8e.png";